import React from 'react';
import HsAsyncSelect from '../Form/HsAsyncSelect';
import { GET_JOURNALS } from './query';
import { strings } from '../../assets/strings/all';

function JournalPicker(props) {
  const { common } = strings;
  const getResultData = (data) => {
    return data.journalList.journals;
  };

  return (
    <HsAsyncSelect
      query={GET_JOURNALS}
      getResultData={getResultData}
      getOptionLabel={(option) => option.title}
      getOptionValue={(option) => option.uuid}
      placeholder={common.start_typing_for_suggestions}
      {...props}
    />
  );
}

export default JournalPicker;
